"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function maid(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M15.9745 9.52736V19.2571L7.75751 14.5269C5.32751 13.1041 5.48201 12.2191 5.48201 10.2969L13.9293 15.1809V10.7191L15.9738 9.52661L15.9745 9.52736Z", fill: color }),
        React.createElement("path", { opacity: 0.6, d: "M13.9299 15.1809L5.4826 10.2961L13.6981 5.56589C16.1281 4.18064 16.8226 4.75814 18.5199 5.71964L10.0726 10.6044L13.9299 12.8349V15.1809Z", fill: color }),
        React.createElement("path", { opacity: 0.2, d: "M10.0728 10.6044L18.52 5.7196V15.1809C18.52 17.9889 17.6718 18.2964 15.9745 19.2579V9.52735L12.0775 11.7571L10.072 10.6036L10.0728 10.6044Z", fill: color }));
}
exports["default"] = maid;
//# sourceMappingURL=maid.js.map